<template>
    <footer name="barocare-b2c-footer" class="barocare-b2c-footer">
        <ul class="btn-group">
            <li><a href="https://policy.soldoc.co.kr/terms" class="btn text-btn" target="_blank" title="새창">이용약관</a></li>
            <li><a href="https://policy.soldoc.co.kr/privacy" class="btn text-btn" target="_blank" title="새창">개인정보처리방침</a></li>
            <li><a href="https://policy.soldoc.co.kr/location" class="btn text-btn" target="_blank" title="새창">위치기반서비스이용약관</a></li>
        </ul>
        <address class="info-wrapper">
            <p class="info">
                <span>솔닥 주식회사 | 대표 : 김민승, 이호익 | 사업자등록번호 : 284-87-00967 | 통신판매업 신고번호 : 2021-서울강남-06329호</span>
                <span>서울특별시 강남구 도산대로 174, 7층(정안빌딩) | E-mail : info@soldoc.co.kr | 대표번호 : 070-8655-2300 | 개인정보관리자 : 김민승</span>
                <span class="copyright">Copyright ⓒ soldoc.co.kr All rights reserved.</span>
            </p>
        </address>
    </footer>
</template>

<script>
export default {
    name: 'BarocareB2cFooter',
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cFooter.vue